<template>
    <div v-ripple @click="click()" class="section" :class="{ 'elevation-3': section === firstIncompleteSection, complete: complete, disabled: !showEnabled }">
        <div :style="{ height: image.height + 'px' }">
            <img :src="image.src" :alt="title" class="section-image" @load="loaded" ref="mapImage" />
        </div>
        <div class="tip subheading primary--text font-weight-bold sansita" v-if="1 === section && section === firstIncompleteSection">
            <v-icon color="primary">arrow_back</v-icon>
            Click here to start
        </div>
        <div class="gutter" :style="{ width: gutterWidth + 'px', height: image.height + 'px' }">
            <img :src="sticker.image" :style="{ 'max-height': image.height + 'px', 'max-width': maxGutterImageWidth }" v-if="sticker.earned" />
            <img
                :src="bonusSticker.image"
                :style="{ 'max-height': image.height + 'px', 'max-width': maxGutterImageWidth }"
                v-if="bonusSticker && bonusSticker.earned"
            />
            <img :src="trophy.image" :style="{ 'max-height': image.height + 'px', 'max-width': maxGutterImageWidth }" v-if="trophy && trophy.earned" />
        </div>
    </div>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

export default {
    props: {
        section: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            image: {
                src: null,
                width: 0,
                height: 0
            },
            gutterWidth: 0,
            maxGutterImageWidth: '100%'
        };
    },
    computed: {
        title() {
            return this.section + ' – ' + this.$store.get(`section${this.section}/title`);
        },
        complete() {
            return this.$store.get(`section${this.section}/complete`) && this.firstIncompleteSection;
        },
        sticker() {
            return this.$store.get(`section${this.section}/sticker`);
        },
        bonusSticker() {
            return this.$store.get(`section${this.section}/bonusSticker`);
        },
        trophy() {
            return this.$store.get(`section${this.section}/trophy`);
        },
        firstIncompleteSection: get('firstIncompleteSection'),
        finished: get('finished'),
        showEnabled() {
            return this.section <= (this.firstIncompleteSection || Number.MAX_VALUE);
        },
        enabled() {
            // enforce not repeating sections until finished with them all first
            return this.section === this.firstIncompleteSection || this.finished;
        }
    },
    methods: {
        click() {
            if (this.enabled || localStorage.devmode) {
                if (this.finished) {
                    this.$store.commit(`section${this.section}/repeatModule`);
                } else {
                    // if the user is restarting an incomplete module, need to
                    // ensure the user gets the current state for the section
                    this.$store.commit(`section${this.section}/resetState`);
                    this.$store.commit('unvisitSection', this.section);
                }
                router.push(`/page/${this.section}/1`);
            }
        },
        loaded() {
            if (this.$refs.mapImage) {
                this.image.width = this.$refs.mapImage.clientWidth;
                this.image.height = this.$refs.mapImage.clientHeight;
                this.gutterWidth = this.image.width * 0.225;
                this.$emit('loaded');
            }
        }
    },
    beforeMount() {
        this.image.src = require(`@/assets/map/map_${this.section}.png`);
        if (this.trophy || this.bonusSticker) {
            this.maxGutterImageWidth = '50%';
        }
    }
};
</script>

<style scoped>
.section {
    position: relative;
}
.section-image {
    width: 100%;
    height: auto;
}
.tip {
    position: absolute;
    top: 22.5%;
    left: 47.5%;
    display: flex;
    align-items: center;
    justify-content: start;
}
.gutter {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}
.gutter img {
    max-width: 100%;
    height: auto;
}
.complete {
    opacity: 0.75;
}
.disabled {
    opacity: 0.1;
}
</style>
